export default "__VITE_ASSET__Cf6AJU82__"